import React, { PropsWithChildren } from 'react';

import styles from './styles.module.css';

export const ErrorOverlayBody: React.FC<PropsWithChildren> = ({ children }) => (
    <div className={styles.children}>{children}</div>
);
